import { render, staticRenderFns } from "./MotivoManage.vue?vue&type=template&id=fe2db9c8&scoped=true"
import script from "./MotivoManage.vue?vue&type=script&lang=js"
export * from "./MotivoManage.vue?vue&type=script&lang=js"
import style0 from "./MotivoManage.vue?vue&type=style&index=0&id=fe2db9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2db9c8",
  null
  
)

export default component.exports